var _adapters;

import defaultAdapter from '../item-types/default/adapter-default';
import storesProductAdapter from '../item-types/stores-product/adapter-stores-product';
import staticPageAdapter from '../item-types/static-page/adapter-static-page';
import staticPageAdapterV2 from '../item-types/static-page-v2/adapter-static-page-v2';
import forumCategoryAdapter from '../item-types/forum/forum-category/adapter-forum-category';
import forumPostAdapter from '../item-types/forum/forum-post/adapter-forum-post';
import proGalleryItemAdapter from '../item-types/pro-gallery/adapter-pro-gallery-item';
import blogCategoryAdapter from '../item-types/blog/blog-category/adapter-blog-category';
import blogPostAdapter from '../item-types/blog/blog-post/adapter-blog-post';
import groupsPostAdapter from '../item-types/groups/groups-post/adapter-groups-post';
import groupsFeedAdapter from '../item-types/groups/groups-feed/adapter-groups-feed';
import groupsAboutAdapter from '../item-types/groups/groups-about/adapter-groups-about';
import groupsMembersAdapter from '../item-types/groups/groups-members/adapter-groups-members';
import groupsMediaAdapter from '../item-types/groups/groups-media/adapter-groups-media';
import eventsPageAdapter from '../item-types/events/adapter-events-page';
import { ITEM_TYPES } from '../types/ItemTypes';
import { enrichWithSiteLevelData } from './utils';
var adapters = (_adapters = {}, _adapters[ITEM_TYPES.STORES_PRODUCT] = storesProductAdapter, _adapters[ITEM_TYPES.STATIC_PAGE] = staticPageAdapter, _adapters[ITEM_TYPES.STATIC_PAGE_V2] = staticPageAdapterV2, _adapters[ITEM_TYPES.FORUM_CATEGORY] = forumCategoryAdapter, _adapters[ITEM_TYPES.FORUM_POST] = forumPostAdapter, _adapters[ITEM_TYPES.PRO_GALLERY_ITEM] = proGalleryItemAdapter, _adapters[ITEM_TYPES.BLOG_CATEGORY] = blogCategoryAdapter, _adapters[ITEM_TYPES.BLOG_POST] = blogPostAdapter, _adapters[ITEM_TYPES.GROUPS_POST] = groupsPostAdapter, _adapters[ITEM_TYPES.GROUPS_FEED] = groupsFeedAdapter, _adapters[ITEM_TYPES.GROUPS_ABOUT] = groupsAboutAdapter, _adapters[ITEM_TYPES.GROUPS_MEDIA] = groupsMediaAdapter, _adapters[ITEM_TYPES.GROUPS_MEMBERS] = groupsMembersAdapter, _adapters[ITEM_TYPES.EVENTS_PAGE] = eventsPageAdapter, _adapters);
export function getAdapter(itemType) {
  var adapter = adapters[itemType];
  return adapter ? enrichWithSiteLevelData(adapter) : defaultAdapter;
}
export var adaptersHandlers = {
  getData: 'function',
  getLegacySeoBlob: 'function',
  getBiData: 'function',
  getKeys: 'function',
  getSlug: 'function',
  updateItemDataWithSlug: 'function'
};